import { createEffect, createEvent, createStore } from 'effector'
import { APIError, APIResult } from '../../core/api/Result'
import { GetLanguagesRes, Language, LanguageAPI } from '../../services/api/Language'
import { setActiveLanguage } from 'react-localize-alias'
import connectLocalStorage from 'effector-localstorage'
import { Common } from '../../shared/enum'

export const $getLanguages = createEffect<unknown, APIResult<typeof LanguageAPI['getLanguages']>, APIError>(
  LanguageAPI.getLanguages,
)

export const $setActiveLanguage = createEvent<string>()

const languagesLocalStorage = connectLocalStorage('languages')
export const $languages = createStore<GetLanguagesRes>(languagesLocalStorage.init([]))
  .on($getLanguages.done, (_, { result }) => {
    const data = result.data.data as GetLanguagesRes
    data.sort(({ code }) => code === Common.DEFAULT_LANGUAGE ? 0 : 1)
    return data
  })
$languages.watch(languagesLocalStorage)

export const $activeLanguage = createStore<Partial<Language>>({ code: Common.DEFAULT_LANGUAGE as string })
  .on($setActiveLanguage, (_, setCode) => {
    const languages = $languages.getState()
    setActiveLanguage(setCode)
    return languages.find(({ code }) => code === setCode)
  })
